// extracted by mini-css-extract-plugin
export default {"dotSize":"30px","dotBorderSize":"3px","dotSizeInner":"20px","dotBorderSizeInner":"5px"};